import styled, { css } from 'styled-components';

// Types
import { ListItemProps, ButtonProps } from './types';

//Components
import { Typography } from '../../../Typography';
import { CheckBox } from '../../../../inputs/CheckBox';
import { ButtonIconBackground } from '../../../../inputs/buttons/ButtonIconBackground';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ListContainer = styled.div`
  position: relative;
`;

export const List = styled.ul`
  width: 17.1rem;
  max-height: 31.5rem;
  border-radius: 0.5rem;
  padding: 0 1.2rem;
  box-shadow: ${({ theme }) => theme.shadows.toast};
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 0.6rem;
  overflow: auto;
  z-index: 9999;
`;

export const ListItem = styled.li<ListItemProps>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: ${({ theme }) => theme.spaces.xs}rem 0;

  &:not(:last-of-type) {
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.paleGrey};
  }

  ${(props) => css`
    ${Text} {
      ${props.disabled && {
        color: props.theme.colors.greyLight,
      }}
    }
    ${StyledCheckBox} {
      ${props.disabled && {
        borderColor: props.theme.colors.greyLight,
      }}
    }
  `}
`;

export const StyledCheckBox = styled(CheckBox)`
  min-width: 1.3rem;
  min-height: 1.3rem;
`;

export const Text = styled(Typography)`
  flex: 1;
`;

export const Button = styled(ButtonIconBackground)<ButtonProps>`
  background-color: ${(props) => props.displayed && props.theme.colors.black};
`;
